import { useEffect, useState } from 'react';

import Loader from '../Loader';
import Pagination from '../Pagination';
import { Profile } from './Profile';
import UsersTableContent from './UsersTableContent';
import UserTableHead from './UsersTableHead';

import { useGetAllUsers } from '@/hooks/users/useGetAllUsers';
import { IUser } from '@/interfaces/entities/user';

export const AllUsers = () => {
	const [selectedUser, setSelectedUser] = useState<IUser | null>(null);
	const [isProfileOpen, setIsProfileOpen] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const { users, isLoading, isError, totalPages, isPending } = useGetAllUsers(
		currentPage,
		10,
	);

	useEffect(() => {
		if (selectedUser?.id) {
			const userId = selectedUser.id;
			const userProfile = users.find((user) => user.id === userId);
			if (userProfile) {
				setSelectedUser(userProfile);
			}
		}
	}, [users]);

	if (isLoading || isPending) {
		return <Loader />;
	}

	if (isError) {
		return <div>Error...</div>;
	}

	const openProfileModal = (user: IUser) => {
		setSelectedUser(user);
		setIsProfileOpen(true);
	};

	const closeProfileModal = () => {
		setIsProfileOpen(false);
		setSelectedUser(null);
	};

	return (
		<div className="px-4 sm:px-6 lg:px-8 w-[85%] ">
			<div className="sm:flex sm:items-center">
				<div className="sm:flex-auto">
					<h1
						className="text-base font-semibold leading-6 text-gray-900"
						data-test="h1-title"
					>
						Users
					</h1>
				</div>
			</div>
			{isProfileOpen && (
				<div className="fixed inset-0 z-[151] flex items-center justify-center bg-black bg-opacity-50">
					<div className="bg-white container max-w-lg p-3 rounded-xl shadow-lg border-2 border-black content-center z-50">
						<Profile
							user={selectedUser as IUser}
							handleProfile={closeProfileModal}
						/>
					</div>
				</div>
			)}
			<div className="mt-8 flow-root">
				<div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
					<div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
						<table className="min-w-full divide-y divide-gray-300 ">
							<UserTableHead />
							<UsersTableContent
								users={users}
								openProfileModal={openProfileModal}
							/>
						</table>
					</div>
				</div>
			</div>
			<Pagination
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
				totalPages={totalPages as number}
			/>
		</div>
	);
};
